module.exports = __webpack_public_path__ + "static/media/bg2.57f1c6c2.jpg";